import { IcoAdd } from "assets/icons";
import { Button, RegisterItem } from "components";
import { ModalVehicleDelete } from "components/Modal";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPartnerUuid } from "services/auth";
import { deleteVehicle, getVehicleModels, getVehicles } from "services/vehicle";
import { setStep } from "store/features/registration/slice";
import styles from "./styles.module.scss";

export default function ManageVehiclesPage() {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [vehicles, setVehicles] = useState<any[]>([]);
	const [partnerId, setPartnerId] = useState("");

	const [showModalVehicleDelete, setShowModalVehicleDelete] = useState(false);
	const [selectedVehicleId, setSelectedVehicleId] = useState<string>("");

	const fetchData = async () => {
		const partnerUuid = (await getPartnerUuid()) || "";
		setPartnerId(partnerUuid);

		const models: any[] = (await getVehicleModels()) || [];
		const modelsMap = new Map(models.map((model) => [model.id, model.name]));

		const result: any[] = (await getVehicles(partnerUuid || "")) || [];

		if (result) {
			setVehicles(result.map((v) => ({ ...v, model: modelsMap.get(v.model) })));
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	const handleEdit = (id: string) => {
		navigate(`/cadastro/veiculos/${id}/editar`);
	};

	const handleDelete = async (id: string) => {
		await deleteVehicle(partnerId, id);
		await fetchData();
	};

	return (
		<form className={styles.form}>
			<ModalVehicleDelete
				open={showModalVehicleDelete}
				onClose={() => setShowModalVehicleDelete(false)}
				onAgree={() => {
					handleDelete(selectedVehicleId);
					setShowModalVehicleDelete(false);
				}}
			/>
			<div className={styles.container}>
				{vehicles.map((vehicle) => (
					<RegisterItem
						carType={vehicle.model.toString()}
						title={vehicle.model.toString()}
						subtitle={vehicle.plate_number}
						onEdit={() => handleEdit(vehicle.id)}
						onDelete={() => {
							setSelectedVehicleId(vehicle.id);
							setShowModalVehicleDelete(true);
						}}
					/>
				))}
				<div className={styles.addButtonWrapper}>
					<Button
						type="button"
						variant="outline"
						onClick={() => {
							navigate("/cadastro/veiculos/novo");
						}}
					>
						<div className={styles.addButton}>
							<IcoAdd />
						</div>
						Novo veículo
					</Button>
				</div>
			</div>
			<div className={styles.buttonWrapper}>
				<Button
					type="button"
					onClick={() => {
						navigate("/cadastro/motoristas");
						dispatch(setStep(3));
					}}
				>
					Próxima
				</Button>
			</div>
		</form>
	);
}
